import { CSSProperties } from 'react';
import useScreen from 'Hooks/useScreen';
import ButtonSymphony from 'elements/ButtonSymphony';
import { ReactComponent as TiktokLogo } from 'assets/images/tiktok-black.svg';
import { ReactComponent as InstagramLogo } from 'assets/images/instagram-bordered-icon.svg';
import { ReactComponent as EditIcon } from 'assets/images/edit.svg';
import SignupWithoutConnections from '../../pages/AddArtist/Components/ConnectPlatformModal/SignupWithoutConnections';
import { useState } from 'react';
import { AnySocialConnectProfile, InstagramProfileForOnboarding, TikTokProfileForOnboarding } from 'modules/Types';
import Colors from 'modules/Colors';
import { SocialConnectType } from 'modules/Const';
import SocialConnectModal from './SocialConnectModal';
import useOnboarding from 'Hooks/useOnboarding';

interface SocialConnectionsButtonsWithModalsProps {
    selectedTikTokProfile: TikTokProfileForOnboarding | null;
    selectedInstagramProfile: InstagramProfileForOnboarding | null;
    onTikTokSelect: (profile: TikTokProfileForOnboarding) => void;
    onInstagramSelect: (profile: InstagramProfileForOnboarding) => void;
    onSignupWithoutConnections: (name: string) => void;
    isOnboarding?: boolean;
}

const SocialConnectionsButtonsWithModals = ({
    selectedTikTokProfile,
    selectedInstagramProfile,
    onTikTokSelect,
    onInstagramSelect,
    onSignupWithoutConnections,
    isOnboarding = false,
}: SocialConnectionsButtonsWithModalsProps) => {
    const {
        mobileView,
        mStyle
    } = useScreen();

    const {
        handleGoNext
    } = useOnboarding();

    const [showSocialConnectModal, setShowSocialConnectModal] = useState<boolean>(false);
    const [socialConnectType, setSocialConnectType] = useState<SocialConnectType | null>(null);
    const [showSignupWithoutConnectionsModal, setShowSignupWithoutConnectionsModal] = useState<boolean>(false);

    const handleShowSocialConnectModal = (type: SocialConnectType) => {
        setSocialConnectType(type);
        setShowSocialConnectModal(true);
    }

    return (
        <>
            <div className="socialConnectionsContainer" style={sty.anotherSocialPlatformContainer}>
                <div
                    className="createAccountWithoutSpotifyTextSocialConnectionsSection"
                    style={sty.createAccountWithoutSpotifyTextSocialConnectionsSection}
                >
                    Or create your account with another social platform:
                </div>

                <div
                    className="platformsButtonsContainer"
                    style={mStyle(sty, 'platformsButtonsContainer')}
                >
                    <ButtonSymphony
                        className="findProfileTikTokButton"
                        width={mobileView ? '100%' : 'auto'}
                        variant="outlined"
                        onClick={() => handleShowSocialConnectModal(SocialConnectType.TIKTOK)}
                        iconLeft={
                            <div>
                                <TiktokLogo width={24} height={24} />
                            </div>
                        }
                        iconRight={selectedTikTokProfile ? <EditIcon /> : undefined}
                    >
                        {selectedTikTokProfile ? `@${selectedTikTokProfile.username}` : 'Connect TikTok'}
                    </ButtonSymphony>

                    <ButtonSymphony
                        className="findProfileInstagramButton"
                        width={mobileView ? '100%' : 'auto'}
                        variant="outlined"
                        onClick={() => handleShowSocialConnectModal(SocialConnectType.INSTAGRAM)}
                        iconRight={selectedInstagramProfile ? <EditIcon /> : undefined}
                        iconLeft={
                            <div>
                                <InstagramLogo width={24} height={24} />
                            </div>
                        }
                    >
                        {selectedInstagramProfile ? `@${selectedInstagramProfile.username}` : 'Connect Instagram'}
                    </ButtonSymphony>
                </div>

                {!selectedTikTokProfile && !selectedInstagramProfile && (
                    <ButtonSymphony
                        className="findProfileNoConnectionsButton1"
                        width={mobileView ? '100%' : 'auto'}
                        style={{
                            marginTop: 16,
                        }}
                        variant="text"
                        onClick={() => setShowSignupWithoutConnectionsModal(true)}
                    >
                        I don't have any of these
                    </ButtonSymphony>
                )}
            </div>

            {/* MODALS */}
            {showSocialConnectModal && socialConnectType &&
                <SocialConnectModal
                    className="socialConnectionsTiktokModal"
                    isOpen={showSocialConnectModal}
                    onClose={() => setShowSocialConnectModal(false)}
                    socialConnectType={socialConnectType as SocialConnectType}
                    isDirectConnect
                    isConnectToBrand={false}
                    onConnect={(connectedProfile: AnySocialConnectProfile) => {
                        switch (socialConnectType) {
                            case SocialConnectType.TIKTOK:
                                onTikTokSelect(connectedProfile as TikTokProfileForOnboarding);
                                break;
                            case SocialConnectType.INSTAGRAM:
                                onInstagramSelect(connectedProfile as InstagramProfileForOnboarding);
                                break;
                        }
                    }}
                />
            }

            <SignupWithoutConnections
                className="signupWithoutConnectionsModalFindProfile"
                open={showSignupWithoutConnectionsModal}
                closeModal={() => setShowSignupWithoutConnectionsModal(false)}
                onSignupWithoutConnections={(name: string) => {
                    onSignupWithoutConnections(name);
                    setShowSignupWithoutConnectionsModal(false);
                    if (isOnboarding) {
                        handleGoNext();
                    }
                }}
            />
        </>
    );
};

const sty: Record<string, CSSProperties> = {
    anotherSocialPlatformContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        width: '100%',
        gap: 8
    },
    platformsButtonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        gap: 16
    },
    platformsButtonsContainer_mobile: {
        flexDirection: 'column',
        gap: 8,
        width: '100%'
    },
    createAccountWithoutSpotifyTextSocialConnectionsSection: {
        fontSize: 18,
        color: Colors.greyDark,
        marginTop: 16,
    },
};

export default SocialConnectionsButtonsWithModals; 